import {DataPersistence as NrwlDataPersistence} from "@nrwl/angular";
import {Injectable, Type} from "@angular/core";
import {Action, ActionCreator, Store} from "@ngrx/store";
import {Actions} from "@ngrx/effects";
import {ActivatedRouteSnapshot} from "@angular/router";

export interface PessimisticUpdateOpts<T, A> {
  run(a: A, state?: T): any;

  onError(a: A, e: any): any;
}

export interface OptimisticUpdateOpts<T, A> {
  run(a: A, state?: T): any;

  undoAction(a: A, e: any): any;
}

export interface FetchOpts<T, A> {
  id?(a: A, state?: T): any;

  run(a: A, state?: T): any;

  onError?(a: A, e: any): any;
}

export interface HandleNavigationOpts<T> {
  run(a: ActivatedRouteSnapshot, state?: T): any;

  onError?(a: ActivatedRouteSnapshot, e: any): any;
}

@Injectable()
export class DataPersistence<T> {
  private dataPersistence: NrwlDataPersistence<T>;

  constructor(public store: Store<T>, actions: Actions) {
    this.dataPersistence = new NrwlDataPersistence<T>(store, actions);
  }

  pessimisticUpdate<A extends Action = Action>(
    actionType: string | ActionCreator,
    opts: PessimisticUpdateOpts<T, A>
  ): any {
    return this.dataPersistence.pessimisticUpdate(actionType, opts);
  }

  optimisticUpdate<A extends Action = Action>(
    actionType: string | ActionCreator,
    opts: OptimisticUpdateOpts<T, A>
  ): any {
    return this.dataPersistence.optimisticUpdate(actionType, opts);
  }

  fetch<A extends Action = Action>(
    actionType: string | ActionCreator,
    opts: FetchOpts<T, A>
  ): any {
    return this.dataPersistence.fetch(actionType, opts);
  }

  navigation(
    component: Type<any>,
    opts: HandleNavigationOpts<T>
  ): any {
    return this.navigation(component, opts);
  }
}
